import { ReactElement } from "react";
import { AnnouncementGlobalSearchResultItem, GlobalSearchScopeIdentifier } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { Highlight } from "client/Components";
import { generateTrackingId } from "client/Misc/utils";
import { useHighlights } from "./useHighlights";
import { TimeZone } from "client/DateAndTime/timezones";
import { AnnouncementListItem } from "client/Features/Hub/Announcements/ListItem/AnnouncementListItem";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import { useAnnouncementNavigationHandler } from "../../../Navigation/useAnnouncementNavigationHandler";

export type AnnouncementItemViewProps = {
	item: AnnouncementGlobalSearchResultItem;
	itemIndex: number;
	itemScope: GlobalSearchScopeIdentifier;
	timezone: TimeZone;
	tabIndex: number;
};

export const AnnouncementItemView = (props: AnnouncementItemViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		itemScope,
		timezone,
		tabIndex
	} = props;

	const highlights: Map<string, Highlight> = useHighlights(item.hitHighlights);

	const {
		id,
		title,
		authorName,
		media,
		categories,
		publicationStart
	} = item.announcement;

	const openHandler: () => void = useAnnouncementNavigationHandler({
		id,
		searchResult: item,
		itemScope: itemScope
	});

	return (
		<GlobalSearchItem
			trackingId={generateTrackingId("announcement-item", `|${id}`)}
			onClick={openHandler}
		>
			<AnnouncementListItem
				title={title}
				authorName={authorName}
				categories={categories}
				media={media}
				publicationStart={publicationStart}
				timezone={timezone}
				highlights={{ title: highlights.get("announcement.title") }}
				trackingId={generateTrackingId("announcement-result-list-item", `|${item.announcement.id}`)}
				itemIndex={itemIndex}
				tabIndex={tabIndex}
				onExecute={openHandler}
			/>
		</GlobalSearchItem>
	);
};

AnnouncementItemView.displayName = "AnnouncementItemView";
